/* eslint-disable import/prefer-default-export */
import { IMetaTag } from '../store/V2/MetaTagsSlice';

export const getMatchingMetaTags = (
  pathName: string,
  metaTags: IMetaTag[] = []
) => {
  const matchingMetaTag = metaTags.find((item) => item.path === pathName);

  if (matchingMetaTag) {
    return matchingMetaTag;
  }

  return null;
};
